document.addEventListener("DOMContentLoaded", () => {
  let formContainer = document.querySelector(
    "#AeGdDNzhCcVREdlAza__forms_inline_dMy3et"
  );

  let observer = new MutationObserver((mutationsList, observer) => {
    let form = document.querySelector("form-embed");

    if (form) {
      observer.disconnect();
      let shadow = form.shadowRoot;

      let sheet = new CSSStyleSheet();
      sheet.insertRule(`
        fieldset legend{
          font-size: 17px !important;
          font-weight: 800 !important;
          letter-spacing: 0.5px !important;
          padding: 15px 0px !important;
          margin: 0 !important;
          font-family: var(--heading-font) !important; 
        }
      `);
      sheet.insertRule(`
        section._formContainer_stahb_30._grid_stahb_148._noImage_stahb_161{
              max-width: 60% !important;
        }
      `);
      sheet.insertRule(`
        button._formSubmitButton_1nihh_77{
          width: 50%;
          margin: 0 auto;
          background: #0b00b5;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 1.1px;
          font-family: "Roboto Condensed", sans-serif;
        }
      `);
      shadow.adoptedStyleSheets.push(sheet);
      formContainer.classList.add("loaded");
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
$(document).on(
  {
    mouseenter: function () {
      let self = $(this);
      self.addClass("active-menu");
    },
    mouseleave: function () {
      let self = $(this);
      self.removeClass("active-menu");
    },
  },
  ".menu-list-box li.menu-item"
);
$(document).on('click', '.middle-banner, .clickable, .media-banner-wrapper.with-add-cart-icon', function(e) {
  if ($(e.target).closest('.product-view-button').length) {
    return; // stop here — no redirect
  }
  let link = $(this).attr('data-href');
  if (link) {
    window.location.href = link;
  }
});
$(document).on('click', '.copy-code', function() {
    let self = $(this);
    let code = self.attr('data-code');
    navigator.clipboard.writeText(code).then(function() {
        self.text('Copied!');
        setTimeout(function() {
            self.text('Copy');
        }, 2000);
    });
});
$(document).on('click', '.slideshow img', function(e) {
    let self = $(this);
    let link = self.parents().eq(1).find('a')
    if (link.length) {
        window.location.href = link.attr('href');
    }
});
$(document).on('click', '#product-after-effects li', function(e) {
    let self = $(this);
    $('.custom-popup').addClass('popup-visible');
    $('.custom-tab-pane p').addClass('d-none');
    $('.popup-tags').find('span').removeClass('active');
    $('.popup-tags').find('span[data-text="' + self.text() + '"]').addClass('active');
    $('.custom-tab-pane').find('p[data-text="' + self.text() + '"]').removeClass('d-none');
});
$(document).on('click', '.popup-tags > span', function(e) {
    let self = $(this);
    $('.popup-tags').find('span').removeClass('active');
    self.addClass('active');
    $('.custom-tab-pane p').addClass('d-none');
    $('.custom-tab-pane p[data-text="' + self.text() + '"]').removeClass('d-none');
});
$(document).on('click', '.popup-close-btn', function(e) {
    $('.custom-popup').removeClass('popup-visible');
});